import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../../context/AlertContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonMui from "@mui/material/Button";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "../Menu";
import { saveAs } from "file-saver";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { jsPDF } from "jspdf";
import { MultiSelect } from "primereact/multiselect";

export default function ListadoCheques(props) {
  const exportColumns = [
    { title: "Fecha", dataKey: "fecha" },
    { title: "Banco", dataKey: "banco" },
    { title: "Depósito", dataKey: "deposito" },
    { title: "Nro.", dataKey: "numero" },
    { title: "Empresa", dataKey: "empresa" },
    { title: "Concepto", dataKey: "concepto" },
    { title: "Detalle", dataKey: "detalle" },
    { title: "Rend/Orden", dataKey: "rendicionOrden" },
    { title: "Importe", dataKey: "importe" },
    { title: "eCheq", dataKey: "echeq" },
    { title: "Estado", dataKey: "estado" },
  ];

  const [listado, setListado] = useState({
    orientacion: "vertical",
    camposSeleccionados: [],
  });
  const [visible, setVisible] = useState(true);
  const toast = useRef(null);
  const [selectedCities, setSelectedCities] = useState([]);
  const [agrupado, setAgrupado] = useState(false);
  const [selectedEstados, setSelectedEstados] = useState([]);
  const [bandInicio, setBandInicio] = useState(false);
  const [exportListado, guardarExportListado] = useState(null);
  const [moneda, guardarMoneda] = useState(null);
  const [tipo, guardarTipo] = useState(null);
  const [tipoFecha, guardarTipoFecha] = useState("ingreso");

  let navigate = useNavigate();

  const estadosCheques = [
    { id: 1, nombre: "CARTERA" },
    { id: 2, nombre: "ACREDITADO" },
    { id: 3, nombre: "DEBITADO" },
    { id: 4, nombre: "VENTANILLA" },
    { id: 5, nombre: "DEPOSITADO" },
    { id: 6, nombre: "RECHAZADO" },
    { id: 7, nombre: "ENTREGADO" },
    { id: 8, nombre: "ANULADO" },
  ];

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    monedas,
    empresas,
    empresaElegida,
    movimientosCheques,
    chequesEgresos,
    chequesIngresos,
    chequesSaldoAnterior,
    chequesSaldoActual,
    monedaPredeterminada,
    obtenerAcceso,
    obtenerListadoCheques,
    obtenerMonedas,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosCheques",
      });
    }
  }, [state]);

  useEffect(() => {
    obtenerMonedas();
    if (monedas && monedaPredeterminada) {
      let mon = monedas.findIndex((item) => item.id === monedaPredeterminada);
      guardarMoneda({
        id_moneda: monedaPredeterminada,
        moneda: monedas[mon].nombre,
      });
    }
  }, [monedas.id_moneda, monedaPredeterminada]);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listado de Cheques",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const aceptarClick = async (exportType) => {
    //e.preventDefault();
    // Validar|

    if (
      !listado ||
      listado.fechaDesde === undefined ||
      listado.fechaDesde === null ||
      listado.fechaDesde === null ||
      listado.fechaDesde === ""
    ) {
      mensajeAlerta(
        "Listados de Cheques",
        "Debe indicar fecha desde !.",
        "error"
      );
      return;
    }

    if (
      !listado ||
      listado.fechaHasta === undefined ||
      listado.fechaHasta === null ||
      listado.fechaHasta === null ||
      listado.fechaHasta === ""
    ) {
      mensajeAlerta(
        "Listados de Cheques",
        "Debe indicar fecha hasta !.",
        "error"
      );
      return;
    }

    if (listado.fechaDesde > listado.fechaHasta) {
      mensajeAlerta(
        "Listados de Cheques",
        "Fecha desde no puede ser mayor que fecha hasta !.",
        "error"
      );
      return;
    }

    if (!tipo || tipo === undefined || tipo === null || tipo === "") {
      mensajeAlerta("Procesos", "Debe indicar tipo de cheque !.", "error");
      return;
    }

    if (selectedEstados && selectedEstados.length === 0) {
      mensajeAlerta(
        "Listados de Cheques",
        "Debe indicar un estado !.",
        "error"
      );
      return;
    }

    if (selectedCities && selectedCities.length === 0) {
      mensajeAlerta(
        "Listados de Cheques",
        "Debe indicar una empresa !.",
        "error"
      );
      return;
    }

    var elem;

    await obtenerListadoCheques({
      desde: listado.fechaDesde,
      hasta: listado.fechaHasta,
      empresasSeleccionadas: selectedCities,
      tipo,
      estados: selectedEstados,
      moneda,
      agrupado,
      tipoFecha,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    onHide();
    //exitClick();
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Listado de Cheques"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>
        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarClick("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarClick("pdf");
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        {/*
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        */}
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const exportExcel = () => {
    for (let i = 0; i < movimientosCheques.length; i++) {
      movimientosCheques[i].importe = movimientosCheques[i].importe.replaceAll(
        ",",
        ""
      );
      movimientosCheques[i].importe = parseFloat(
        movimientosCheques[i].importe,
        10
      );
    }
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(movimientosCheques);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "cheques");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName +
            "_export_" +
            new Date().toLocaleDateString() +
            EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
    startClick();
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape");
        const fechaHoraActual = new Date();

        doc.setFontSize(12);
        doc.text(
          "Listado de Cheques Desde " +
            formatDate(listado.fechaDesde) +
            " Hasta " +
            formatDate(listado.fechaHasta),
          30,
          8
        );
        doc.text(fechaHoraActual.toLocaleDateString("es-ES"), 220, 8);

        let empresas = "";
        for (let i = 0; i < selectedCities.length; i++) {
          if (i === 0) {
            empresas = selectedCities[i].nombre;
          } else {
            empresas = empresas + " - " + selectedCities[i].nombre;
          }
        }

        doc.setFontSize(8);
        doc.text(`Empresas: ${empresas}`, 30, 13);

        doc.autoTable(exportColumns, movimientosCheques, {
          styles: {
            fontSize: 7,
          },

          columnStyles: {
            7: {
              halign: "right",
            },
          },
          didParseCell: (data) => {
            if (data.cell && data.cell.section === "head") {
              switch (data.cell.raw) {
                case "importe":
                  data.cell.styles.halign = "right";
                  break;
                default:
                  data.cell.styles.halign = "left";
                  break;
              }
            }
          },
        });
        window.open(doc.output("bloburl"));
        //doc.save("residentes_caidas_" + new Date().toLocaleDateString() +".pdf");
      });
    });
    startClick();
  };

  const startClick = (e) => {
    setTimeout(() => {
      //navigate("listadosservicios");
      setVisible(true);
    }, 2000);
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  // INICIO

  if (!bandInicio && empresas && empresas.length > 0 && empresaElegida) {
    setBandInicio(true);
    const index = empresas.findIndex((item) => item.id === empresaElegida.id);
    if (index !== -1) {
      let final = [];
      final.push(empresas[index]);
      setSelectedCities(final);
    }
  }

  // FIN

  //console.log(movimientosCheques);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeader()}
            visible={visible}
            closable={false}
            footer={renderFooter()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "75vw", paddingBottom: "0" }}
            position="center"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              <Grid item xs={12} md={12}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="tipoFecha"
                    value={tipoFecha ? tipoFecha : null}
                    onChange={(e) => guardarTipoFecha(e.target.value)}
                  >
                    <FormControlLabel
                      value="ingreso"
                      control={<Radio />}
                      label="Ingreso"
                    />
                    <FormControlLabel
                      value="deposito"
                      control={<Radio />}
                      label="Deposito"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="fechaDesde"
                  label="Fecha desde"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={listado ? listado.fechaDesde : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setListado({
                      ...listado,
                      fechaDesde: e.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="fechaHasta"
                  label="Fecha hasta"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={listado ? listado.fechaHasta : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setListado({
                      ...listado,
                      fechaHasta: e.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="tipo"
                    value={tipo ? tipo : null}
                    onChange={(e) => guardarTipo(e.target.value)}
                  >
                    <FormControlLabel
                      value="terceros"
                      control={<Radio />}
                      label="Terceros"
                    />
                    <FormControlLabel
                      value="Propios"
                      control={<Radio />}
                      label="Propios"
                    />
                    <FormControlLabel
                      value="todos"
                      control={<Radio />}
                      label="Todos"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid
                item
                xs={6}
                md={12}
                style={{ marginLeft: "0vw", marginLeft: "0vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="agrupado"
                      checked={agrupado ? agrupado : false}
                      onChange={(e) => {
                        setAgrupado(e.target.checked);
                      }}
                    />
                  }
                  label="Agrupado"
                  labelPlacement="start"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Estados</label>

                <MultiSelect
                  value={selectedEstados}
                  onChange={(e) => setSelectedEstados(e.value)}
                  options={estadosCheques}
                  optionLabel="nombre"
                  placeholder="Seleccione un estado"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                  //className="w-full md:w-40rem"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Empresas</label>

                <MultiSelect
                  value={selectedCities}
                  onChange={(e) => setSelectedCities(e.value)}
                  options={
                    empresas ? empresas.filter((item) => item.habilitado) : null
                  }
                  optionLabel="nombre"
                  placeholder="Seleccione las empresas"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                  //className="w-full md:w-40rem"
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}
/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
